import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md',
  color = 'var(--color-primary)'
}) => {
  return (
    <div 
      className={`loading-spinner loading-spinner--${size}`}
      style={{ borderTopColor: color }}
    />
  );
};
